// Angular imports
import { Component, OnDestroy, OnInit } from '@angular/core';

// 3rd party imports
import { Subscription } from 'rxjs';

// CC-Common imports
import { Utils } from 'cc-common';

// Service imports
import { ContextManagerService } from '../../../_services/data-services/context-manager.service';
import { CiraHelpService } from '../../../_services/shared-services/cira-help.service';

// Constant imports
import { ContactConstants } from '../../../_constants/contact-constants';

// Model imports
import { PropertyCommunityInfoResultDto } from '../../../_models/property-community-info-result-dto';

@Component({
    selector: 'app-external-user-contact-us',
    templateUrl: './external-user-contact-us.component.html',
    styleUrls: ['./external-user-contact-us.component.scss']
})
export class ExternalUserContactUsComponent implements OnInit, OnDestroy {
    contactEmail: string = ContactConstants.contactUsEmail;
    contactUsPhone: string = ContactConstants.contactUsPhone;
    contactUsPhoneDisplayText: string = ContactConstants.contactUsPhoneDisplayText;
    selectedContext: PropertyCommunityInfoResultDto;
    contextChangeSubscription: Subscription;

    navigationHelpKey: string;
    boardapprovalsInvHelpKey: string;
    propertyOwnerSeaarchHelpKey: string;
    payableLockboxSearchInvHelpKey: string;
    customReportingGridPageHelpKey: string;
    customWorkspaceHelpKey: string;
    boardapprovalsCollationHelpKey: string;
    communityDocHelpKey: string;
    payableLockboxSubmitInvHelpKey: string;
    communityCalHelpKey: string;
    finActualBudgetHelpKey: string;
    boardApprovalsArchitecturalHelpKey: string;
    communityReportsHelpKey: string;
    vendorContractsInsuranceHelpKey: string;
    residentDirectoryHelpKey: string;
    welcomeHelpKey: string;

    ciraHelpWindow: Window;

    constructor(
        private readonly ciraHelpService: CiraHelpService,
        private readonly contextManagerService: ContextManagerService
    ) {}

    ngOnInit(): void {
        this.updateSelectedContext();
        this.contextChangeSubscription = this.contextManagerService
            .getContext()
            .subscribe(this.updateSelectedContext.bind(this));
        // TODO: Url not available for now, once available will make the change
        this.navigationHelpKey = 'BD_Navigation';
        this.boardapprovalsInvHelpKey = 'BD_Approvals_Invoices';
        this.propertyOwnerSeaarchHelpKey = 'BD_Property_Owner_Search';
        this.payableLockboxSearchInvHelpKey = 'BD_CiraBooks_AP_Search_Invoices';
        this.customReportingGridPageHelpKey = 'BD_Grids_Pages';
        this.customWorkspaceHelpKey = 'BD_Workspaces_Main';
        this.boardapprovalsCollationHelpKey = 'BD_Approvals_Invoices';
        this.communityDocHelpKey = 'BD_Community_Document_Archive';
        this.payableLockboxSubmitInvHelpKey = 'BD_CiraBooks_AP_Submit_Invoices';
        this.communityCalHelpKey = 'BD_Community_Calendar';
        this.finActualBudgetHelpKey = 'BD_CiraBooks_ActualvBudget';
        this.boardApprovalsArchitecturalHelpKey = 'BD_Approvals_Invoices';
        this.communityReportsHelpKey = 'BD_Reports';
        this.vendorContractsInsuranceHelpKey = 'BD_Vendor_Management';
        this.residentDirectoryHelpKey = 'BD_Resident_Directory';
        this.welcomeHelpKey = 'BD_Welcome';
    }

    ngOnDestroy(): void {
        if (Utils.notNullAndDefined(this.contextChangeSubscription)) {
            this.contextChangeSubscription.unsubscribe();
        }
    }

    onTileClick(helpKey: string): void {
        const helpLink = this.ciraHelpService.getHelpLinkByKey(helpKey);

        if (Utils.notNullAndDefined(helpKey)) {
            if (Utils.isNullOrUndefined(this.ciraHelpWindow) || this.ciraHelpWindow.closed) {
                this.ciraHelpWindow = window.open(helpLink, '_blank');
            } else {
                this.ciraHelpWindow.location.href = helpLink;
            }
            if (Utils.notNullAndDefined(this.ciraHelpWindow)) {
                this.ciraHelpWindow.focus();
            }
        }
    }

    onToolMouseEnter(event: any, data: any): void {
        if (Utils.notNullOrEmpty(data.helpKey)) {
            event.srcElement.classList.add('contact-us-tile-hover', 'cc-hyperlink');
        }
    }

    onToolMouseLeave(event: any): void {
        event.srcElement.classList.remove('contact-us-tile-hover', 'cc-hyperlink');
    }

    private updateSelectedContext(): void {
        this.selectedContext = this.contextManagerService.getSelectedContext();
    }
}
